<h3>Estado de los envíos</h3>
<div class="square">
  <div *ngIf="resumenEstados==undefined" class="spinner">
      <mat-spinner diameter="35" strokeWidth="2"></mat-spinner>
  </div>
  <app-resumen-estados-sqp *ngIf="resumenEstados"
                           (clickEstado)="estadosFirmaService.clickEstadoEnvio($event); goToFirmas()"
                           [estadoSeleccionado]="estadosFirmaService.estadoSeleccionado"
                           [verNuevos]="true"
                           [resumenEstados]="resumenEstados"
                           ></app-resumen-estados-sqp>
</div>
